<app-section sectionTitle="Craft Group Management">
  <!-- MARK: Save -->
  <app-subsection subSectionTitle="Save">
    <div style="margin-bottom: 10px; display: flex; flex-direction: column; gap: 8px; align-items: start; margin-top: 15px">
      <button mat-fab extended color="primary" matTooltip="Save Current Craft Group" [disabled]="this.craftCalculatorStateService.disableButtons() || !afmBeService.userHasMasterpieceEntitlement()" (click)="saveCurrentCraftGroup()">
        {{ this.craftCalculatorStateService.craftGroup().id() ? 'Update current craft group' : 'Save current craft group as new' }}
      </button>
      @if (!afmBeService.userHasMasterpieceEntitlement()) {
        <p style="margin-top: -7px; font-size: 0.7rem; opacity: 0.65; margin-bottom: 0; margin-left: 3px">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle; margin-right: 3px">info</mat-icon>
          Requires <a routerLink="/support-us">Masterpiece</a> Support
        </p>
      }
      <mat-form-field style="max-width: 280px">
        <mat-label>Craft Group Name</mat-label>
        <input matInput type="text" [(ngModel)]="this.craftCalculatorStateService.craftGroup().name" />
      </mat-form-field>
    </div>
  </app-subsection>

  <!-- MARK: Load -->
  <app-subsection subSectionTitle="Load">
    <button
      mat-fab
      extended
      color="primary"
      matTooltip="Load User Craft Groups"
      [disabled]="this.craftCalculatorStateService.disableButtons() || !afmBeService.userHasMasterpieceEntitlement()"
      (click)="this.craftCalculatorStateService.loadUserCraftGroup()"
    >
      Load User Craft Groups
    </button>
    @if (!afmBeService.userHasMasterpieceEntitlement()) {
      <p style="margin-top: 1px; font-size: 0.7rem; opacity: 0.65; margin-bottom: 0; margin-left: 3px">
        <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle; margin-right: 3px">info</mat-icon>
        Requires <a routerLink="/support-us">Masterpiece</a> Support
      </p>
    }

    <!-- MARK: CraftGroups -->
    <div style="margin-bottom: 10px; display: flex; flex-wrap: wrap; gap: 16px; align-items: start; margin-top: 15px; width: 100%">
      @for (craftGroup of craftCalculatorStateService.userCraftGroups(); track craftGroup.id()) {
        <mat-card [style]="'width: 300px; min-height: 230px; flex-shrink: 0; border: ' + (craftCalculatorStateService.craftGroup().id() === craftGroup.id() ? '3px solid var(--accent-color)' : 'none')">
          <mat-card-content style="padding: 16px">
            <!-- Item Images -->
            <div style="display: flex; justify-content: center; gap: 8px; margin-bottom: 12px; flex-wrap: wrap">
              @for (product of craftGroup.craftCategoryTopItems(); track product.uniqueName) {
                <app-item-image [item]="product" [size]="50" />
              }
            </div>

            <!-- Title -->
            <h3 style="margin: 0 0 12px 0; font-weight: 500; text-align: center; font-size: 1rem">
              {{ craftGroup.name() }}
            </h3>

            <!-- Info Grid -->
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px; font-size: 0.875rem">
              <div style="text-align: center">
                <div style="opacity: 0.7; margin-bottom: 2px">Crafts</div>
                <span style="font-weight: 500">{{ craftGroup.crafts().length }}</span>
              </div>

              <div style="text-align: center">
                <div style="opacity: 0.7; margin-bottom: 2px">Updated</div>
                <span style="font-weight: 500">
                  @if (craftGroup.updatedAt()) {
                    {{ craftGroup.updatedAt() | date: 'short' }}
                  } @else {
                    No date
                  }
                </span>
              </div>
            </div>

            <!-- Action Buttons -->
            <div style="display: flex; gap: 8px; justify-content: center">
              <button mat-raised-button color="primary" matTooltip="Load to Current" (click)="this.craftCalculatorStateService.craftGroup.set(craftGroup)">Load</button>
              <button mat-raised-button color="primary" matTooltip="Clone" (click)="cloneCraftGroup(craftGroup)">Clone</button>
              <button mat-raised-button color="warn" matTooltip="Delete" [disabled]="this.craftCalculatorStateService.disableButtons()" (click)="deleteCraftGroup(craftGroup)">Delete</button>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </div>
  </app-subsection>
</app-section>

<!-- MARK: History -->
<app-section sectionTitle="Your Crafts History">
  <app-subsection subSectionTitle="Save">
    <div style="margin-bottom: 10px; display: flex; flex-direction: column; gap: 8px; align-items: start; margin-top: 15px">
      <button
        mat-fab
        extended
        color="primary"
        matTooltip="Save Current Craft As Done"
        [disabled]="this.craftCalculatorStateService.disableButtons() || !this.craftCalculatorStateService.craftGroup().isOkToSaveAsDoneCraft() || !afmBeService.userHasMasterpieceEntitlement()"
        (click)="this.saveCurrentCraftGroupAsDoneCraft()"
      >
        Save Current Craft as Done
      </button>
      @if (!afmBeService.userHasMasterpieceEntitlement()) {
        <p style="margin-top: -7px; font-size: 0.7rem; opacity: 0.65; margin-bottom: 0; margin-left: 3px">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle; margin-right: 3px">info</mat-icon>
          Requires <a routerLink="/support-us">Masterpiece</a> Support
        </p>
      }
    </div>
    @if (!this.craftCalculatorStateService.craftGroup().isOkToSaveAsDoneCraft()) {
      <p>The current craft group is not ready to be saved as done. Ensure it has at least one selectedd craft and all user prices are set.</p>
    }
  </app-subsection>

  <app-subsection subSectionTitle="Done Crafts History">
    <div style="margin-bottom: 10px; display: flex; flex-direction: column; gap: 8px; align-items: start; margin-top: 15px">
      <button
        mat-fab
        extended
        color="primary"
        matTooltip="Load Done Crafts History"
        [disabled]="this.craftCalculatorStateService.disableButtons() || !afmBeService.userHasMasterpieceEntitlement()"
        (click)="this.craftCalculatorStateService.loadUserDoneCrafts()"
      >
        Load Done Crafts History
      </button>
      @if (!afmBeService.userHasMasterpieceEntitlement()) {
        <p style="margin-top: -7px; font-size: 0.7rem; opacity: 0.65; margin-bottom: 0; margin-left: 3px">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle; margin-right: 3px">info</mat-icon>
          Requires <a routerLink="/support-us">Masterpiece</a> Support
        </p>
      }
      @if (sortedDoneCrafts().length === 0) {
        <p style="margin-top: 16px; opacity: 0.7">No done crafts history found. Complete some crafts to see them here!</p>
      } @else {
        @defer {
          <div class="table mat-elevation-z8">
            <table mat-table [dataSource]="doneCraftsDataSource()" #doneCraftsSort="matSort" matSort matSortStart="desc" [trackBy]="trackByDoneCraftId">
              <!-- Items -->
              <ng-container matColumnDef="items">
                <th mat-header-cell *matHeaderCellDef class="min-width-120">Items</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <div style="display: flex; flex-direction: column; gap: 4px; align-items: center">
                    @for (product of doneCraft.craftGroup.usedProductOutputItems(); track product.item.uniqueName) {
                      <app-item-image [item]="product.item" [size]="40" />
                    }
                  </div>
                </td>
              </ng-container>

              <!-- Name -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-180">Name</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span>{{ doneCraft.craftGroup.name() }}</span>
                </td>
              </ng-container>

              <!-- Server -->
              <ng-container matColumnDef="server">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-180">Server</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span>{{ getServerName(doneCraft.craftGroup.server()) }}</span>
                </td>
              </ng-container>

              <!-- Total Income -->
              <ng-container matColumnDef="totalIncome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Total Income</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span>{{ doneCraft.totalIncome | number: '1.0-0' }}</span>
                </td>
              </ng-container>

              <!-- Total Expenses -->
              <ng-container matColumnDef="totalExpenses">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Total Expenses</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span>{{ doneCraft.totalExpenses | number: '1.0-0' }}</span>
                </td>
              </ng-container>

              <!-- Input Weight -->
              <ng-container matColumnDef="totalInputWeight">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Input Weight</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span>{{ doneCraft.totalInputWeight | number: '1.0-0' }} kg</span>
                </td>
              </ng-container>

              <!-- Output Weight -->
              <ng-container matColumnDef="totalOutputWeight">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Output Weight</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span>{{ doneCraft.totalOutputWeight | number: '1.0-0' }} kg</span>
                </td>
              </ng-container>

              <!-- Total Fame -->
              <ng-container matColumnDef="totalFame">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Total Fame</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span>{{ doneCraft.totalCraftFamePlayerTotal | number: '1.0-0' }}</span>
                </td>
              </ng-container>

              <!-- Total Focus -->
              <ng-container matColumnDef="totalFocus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Total Focus</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span>{{ doneCraft.totalFocus > 0 ? (doneCraft.totalFocus | number: '1.0-0') : '-' }}</span>
                </td>
              </ng-container>

              <!-- Profit Per Focus -->
              <ng-container matColumnDef="profitPerFocus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Profit Per Focus</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span>{{ doneCraft.totalFocus > 0 ? (doneCraft.totalResult / doneCraft.totalFocus | number: '1.0-0') : '-' }}</span>
                </td>
              </ng-container>

              <!-- Total Craft Fee -->
              <ng-container matColumnDef="totalCraftFee">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Total Craft Fee</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span>{{ doneCraft.totalFee | number: '1.0-0' }}</span>
                </td>
              </ng-container>

              <!-- Profit -->
              <ng-container matColumnDef="profit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Profit</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span [style.color]="doneCraft.totalResult >= 0 ? '#4caf50' : '#f44336'"> {{ doneCraft.totalResult | number: '1.0-0' }} ({{ doneCraft.totalResult / doneCraft.totalExpenses | percent: '1.2-2' }}) </span>
                </td>
              </ng-container>

              <!-- Craft Date -->
              <ng-container matColumnDef="craftDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-140">Completed</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <span>
                    @if (doneCraft.craftDate) {
                      {{ doneCraft.craftDate | date: 'short' }}
                    } @else {
                      No date
                    }
                  </span>
                </td>
              </ng-container>

              <!-- Actions -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="min-width-200">Actions</th>
                <td mat-cell *matCellDef="let doneCraft">
                  <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(80px, 1fr)); gap: 8px; margin: 8px 0 8px 0">
                    <button mat-raised-button color="primary" [disabled]="!afmBeService.userHasMasterpieceEntitlement()" (click)="cloneCraftGroup(doneCraft.craftGroup)">Clone</button>
                    <button mat-raised-button color="warn" [disabled]="this.craftCalculatorStateService.disableButtons() || !afmBeService.userHasMasterpieceEntitlement()" (click)="deleteDoneCraft(doneCraft)">Delete</button>
                  </div>
                  @if (!afmBeService.userHasMasterpieceEntitlement()) {
                    <p style="margin-top: 4px; font-size: 0.7rem; opacity: 0.65; margin-bottom: 0">
                      <mat-icon style="font-size: 12px; width: 12px; height: 12px; vertical-align: middle; margin-right: 3px">info</mat-icon>
                      Requires <a routerLink="/support-us">Masterpiece</a> Support
                    </p>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="doneCraftsDisplayedColumns(); sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: doneCraftsDisplayedColumns()"></tr>
            </table>
          </div>
          <div style="width: 100%">
            <mat-paginator #doneCraftsPaginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons aria-label="Select page of done crafts"> </mat-paginator>
          </div>
        } @placeholder {
          <p>Loading done crafts...</p>
        }
      }
    </div>
  </app-subsection>
</app-section>
